<template>
  <div class="title-section" :style="{'background-image': 'url(https://static.igem.wiki/teams/4185/wiki/' + image_src + ')'}">
    <div class="title">
        <h1>{{ this.title }}</h1>
    </div>
    <WaveAnimation wave_order="title-page"/>
  </div>
</template>
<script>

import WaveAnimation from '../components/WaveAnimation.vue'

export default {
    name: 'TitleScreen',
    props: ['title', 'image_src'] ,
    components: {
      WaveAnimation
    }
}
</script>

<style lang="scss">

  .title-section {
    height: 100vh;
    // position: relative;
    // z-index: 1;

    // &.Description {
    //   background-image: url('../assets/img/filler-img.png');
    // }

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;


    .title {
      background: #01262F;
      width: max-content;
      position: absolute;
      left: 50%;
      top: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);

      h1 {
        color: #fff;
        padding: 0.4em;
        //font-size: 80px;
        font-size: 6vw;
      }
    }
  }
</style>
